<template>
  <div class="view-container">
    <form id="success" class="payment-result-form">
      <h1>Success</h1>
      <span>Your payment has been approved.</span>
      <span v-if="Branch.id != null && Order.payment == false"
        >Your order {{ Branch.prepTime > 0 ? 'will be' : 'is' }} ready for
        {{ Order.delivery ? 'delivery' : 'collection'
        }}{{ Branch.prepTime > 0 ? ' in ' + Branch.prepTime + 'min.' : '.' }}
      </span>
      <br /><br />
      <router-link
        v-if="$isTab || $tableNo"
        to="/Seating"
        class="btn btn-primary"
      >
        Continue Ordering
      </router-link>
      <router-link v-else to="/Menu" class="btn btn-primary">
        Continue Ordering
      </router-link>
      <br /><br />
      <router-link to="/History" class="btn btn-secondary">
        View History
      </router-link>
    </form>
  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: 'Success',
  components: {},
  data() {
    return {
      Branch: {},
      Order: {}
    };
  },
  mounted() {
    var _self = this;
    var data = {
      FranchiseID: _self.$franchiseID,
      MembershipUserID: localStorage.userMembershipID,
      PaymentReference: _self.getParameterByName('PaymentReference'),
      CartGuid: localStorage.cartGuid,
      InvoiceUrl:
        window.location.origin +
        '/History?id=' +
        _self.$franchiseID +
        '&franchise=' +
        _self.$franchiseName
    };
    _self.$ooApi.orders.payment.success.v1(data).then(function(result) {
      _self.Branch = result.data.branch;
      _self.Order = result.data.order;
      _self.clearPayComputed();
    });
  }
};
</script>
